import { ModalActions } from '@ui-kit/components/Modal/Modal';
import { useTranslation } from 'react-i18next';
import { AnchorButton } from '@/components/buttons';
import type { ModalProps } from '@/components/ModalRenderer/components/types';
import { Modal } from '@/components/ModalRenderer/Modal';
import { getConfig } from '@/constants/config';
import Button from '@/ui-kit/components/Button/Button';

const BankAccountUpdateFail = ({ confirmAction }: ModalProps) => {
  const { t } = useTranslation(['Modal', 'Button', 'Common']);

  return (
    <Modal title={t('BankAccountUpdateFail.title')}>
      <p>{t('BankAccountUpdateFail.info')}</p>
      <ModalActions>
        <Button onClick={confirmAction}>{t('Button:tryAgain')}</Button>
        <AnchorButton variant="secondary" href={getConfig().externalLinks.contact}>
          {t('Common:contactUs')}
        </AnchorButton>
      </ModalActions>
    </Modal>
  );
};

export default BankAccountUpdateFail;
